let intersectionObserver = null;
let mutationObserver = null;
let processedElements = new WeakSet();

function isValidNumber(value, fallback) {
  const numericValue = Number(value);
  return Number.isFinite(numericValue) ? numericValue : fallback;
}

function applyInitialStylesForElement(targetElement) {
  const durationMs = isValidNumber(targetElement.dataset.aosDuration, 500);
  const delayMs = isValidNumber(targetElement.dataset.aosDelay, 0);
  const easing = targetElement.dataset.aosEasing || 'ease-out';

  targetElement.style.transitionProperty = 'opacity, transform';
  targetElement.style.transitionTimingFunction = easing;
  targetElement.style.transitionDuration = `${durationMs}ms`;
  targetElement.style.transitionDelay = `${delayMs}ms`;
}

function observeElement(targetElement, options) {
  if (!intersectionObserver) {
    return;
  }

  const type = (targetElement.getAttribute('data-aos') || '').trim();
  if (!type || type === 'none') {
    // If no animation or explicitly 'none', ensure visible and skip observing
    targetElement.classList.add('aos-lite-in');
    applyInitialStylesForElement(targetElement);
    processedElements.add(targetElement);
    return;
  }

  if (processedElements.has(targetElement)) {
    return;
  }

  applyInitialStylesForElement(targetElement);
  intersectionObserver.observe(targetElement);
}

function scanAndObserve(options) {
  const candidates = document.querySelectorAll('[data-aos]');
  candidates.forEach((element) => {
    if (!processedElements.has(element)) {
      observeElement(element, options);
    }
  });
}

function handleIntersections(entries, observer, options) {
  entries.forEach((entry) => {
    const targetElement = entry.target;
    const onceAttr = targetElement.getAttribute('data-aos-once');
    const once = onceAttr === null ? options.once : onceAttr !== 'false';

    if (entry.isIntersecting) {
      targetElement.classList.add('aos-lite-in');
      if (once) {
        processedElements.add(targetElement);
        observer.unobserve(targetElement);
      }
    } else if (!once) {
      targetElement.classList.remove('aos-lite-in');
    }
  });
}

export function initAosLite(userOptions = {}) {
  const options = {
    once: true,
    root: null,
    rootMargin: '0px 0px -10% 0px',
    threshold: 0.1,
    ...userOptions,
  };

  if (intersectionObserver) {
    try {
      intersectionObserver.disconnect();
    } catch (e) { /* noop */ }
  }

  intersectionObserver = new IntersectionObserver((entries) => {
    handleIntersections(entries, intersectionObserver, options);
  }, {
    root: options.root || null,
    rootMargin: options.rootMargin,
    threshold: options.threshold,
  });

  scanAndObserve(options);

  if (mutationObserver) {
    try { mutationObserver.disconnect(); } catch (e) { /* noop */ }
  }

  mutationObserver = new MutationObserver((mutations) => {
    let needsScan = false;
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList') {
        needsScan = true;
      }
    });
    if (needsScan) {
      scanAndObserve(options);
    }
  });

  mutationObserver.observe(document.body, { childList: true, subtree: true });
}

export function refreshAosLite() {
  // Re-scan for any new elements and observe them
  if (intersectionObserver) {
    scanAndObserve({ once: true });
  }
}

export function destroyAosLite() {
  if (intersectionObserver) {
    try { intersectionObserver.disconnect(); } catch (e) { /* noop */ }
    intersectionObserver = null;
  }
  if (mutationObserver) {
    try { mutationObserver.disconnect(); } catch (e) { /* noop */ }
    mutationObserver = null;
  }
  processedElements = new WeakSet();
}


